import React, { Component } from "react";
import Footer from "../footer/footer";
import HeaderNew from "../header/header";

class MailChimp extends Component {
    render() {
        return (
            <div className='container'>
                <div className='mail-chimp'>
                    <div className='title'>
                        Reach out to us :
                    </div>
                    <p className='description'>lcochrane@hbku.edu.qa</p>
                    {/* <div className='subscribe flex-row'>
                        <input type="text" placeholder='Enter Your Email' />
                        <div className='button' >Subscribe</div>
                    </div> */}
                </div>
            </div>
        )
    }
} export default MailChimp;